import { DateTime } from 'luxon';
import { useMemo } from 'react';

export const formatDate = (date: string, format: string = 'M/d/y'): string => {
  const parsedDate = DateTime.fromISO(date);

  if (!parsedDate.isValid) {
    return '-';
  }

  return parsedDate.toFormat(format);
};

const useFormattedDate = (date: string, format: string = 'M/d/y'): string =>
  useMemo(() => formatDate(date, format), [date]);

export default useFormattedDate;
